import React from 'react';

export default props => (
  <div className={'no_records'}>
    {props.typ === "angebot" && <h2>Keine Angebot gefunden</h2>}
    {props.typ === "gesuch" && <h2>Keine Gesuche gefunden</h2>}
  </div>
);